export default {
  LIST_REQUEST: "GENDER_LIST_REQUEST",
  LIST_SUCCESS: "GENDER_LIST_SUCCESS",
  LIST_FAILURE: "GENDER_LIST_FAILURE",
};
